/**
 * Timetable Module - TZN WP Theme
 * Obsługa dynamicznego pobierania i wyświetlania planu lekcji z systemu Vulcan
 */

function initTimetable() {
  const root = document.querySelector('.js-timetable-root');
  if (!root) {
    return;
  }

  const selectOddzialy = root.querySelector('.js-timetable-select-oddzialy');
  const selectNauczyciele = root.querySelector(
    '.js-timetable-select-nauczyciele',
  );
  const selectSale = root.querySelector('.js-timetable-select-sale');
  const submitBtn = root.querySelector('.js-timetable-submit');
  const tableWrapper = root.querySelector('.js-timetable-wrapper');
  const titleElem = root.querySelector('.js-timetable-title');
  const notesElem = root.querySelector('.js-timetable-notes');
  const generatedWrapper = root.querySelector('.js-timetable-generated');
  const generatedDateElem = root.querySelector('.js-timetable-generated-date');

  const ajaxUrl =
    (window.tznTimetableData && window.tznTimetableData.ajaxUrl) ||
    '/wp-admin/admin-ajax.php';

  let currentPlanId = root.getAttribute('data-initial-plan') || 'o1';

  /**
   * Synchronizuje stan pól select z wybranym plan_id (np. 'o1', 'n69', 's12')
   */
  function syncSelectsWithPlanId(planId) {
    if (!planId) return;

    const prefix = planId.charAt(0).toLowerCase();
    const val = planId.substring(1);

    if (prefix === 'o') {
      if (selectOddzialy) selectOddzialy.value = val;
      if (selectNauczyciele) selectNauczyciele.selectedIndex = 0;
      if (selectSale) selectSale.selectedIndex = 0;
    } else if (prefix === 'n') {
      if (selectNauczyciele) selectNauczyciele.value = val;
      if (selectOddzialy) selectOddzialy.selectedIndex = 0;
      if (selectSale) selectSale.selectedIndex = 0;
    } else if (prefix === 's') {
      if (selectSale) selectSale.value = val;
      if (selectOddzialy) selectOddzialy.selectedIndex = 0;
      if (selectNauczyciele) selectNauczyciele.selectedIndex = 0;
    }
  }

  /**
   * Generuje kod HTML tabeli na podstawie danych z API
   */
  function buildTableHtml(plan) {
    if (!plan || !plan.rows || !plan.rows.length) {
      return `
        <div class="timetable-page__error">
          <p class="medium-text">${plan?.message || 'Brak danych planu lekcji.'}</p>
        </div>
      `;
    }

    const days = plan.days || [
      'Poniedziałek',
      'Wtorek',
      'Środa',
      'Czwartek',
      'Piątek',
    ];

    let html = `
      <table class="timetable-page__table js-timetable-table">
        <thead>
          <tr>
            <th scope="col" class="bold-text">Godzina</th>
    `;

    days.forEach((day) => {
      html += `<th scope="col" class="bold-text small-text">${day}</th>`;
    });

    html += `
          </tr>
        </thead>
        <tbody>
    `;

    plan.rows.forEach((row) => {
      html += `
        <tr>
          <td class="timetable-page__hour-cell bold-text small-text">
            ${row.time || ''}
          </td>
      `;

      const cells = row.cells || [];
      for (let i = 0; i < 5; i++) {
        const cell = cells[i];
        const entries = cell ? cell.entries || [] : [];

        html += `<td>`;

        if (entries.length > 0) {
          html += `<div class="timetable-page__lessons-list">`;
          entries.forEach((entry) => {
            html += `<div class="timetable-page__lesson extra-small-text">`;

            if (entry.subject) {
              html += `<span class="timetable-page__subject">${entry.subject}</span>`;
            }

            if (entry.teacher) {
              html += `<a href="?plan=${entry.teacher.id}" class="timetable-page__link timetable-page__link--teacher bold-text js-timetable-link" data-plan-id="${entry.teacher.id}" title="Plan nauczyciela">${entry.teacher.code}</a>`;
            }

            if (entry.class) {
              html += `<a href="?plan=${entry.class.id}" class="timetable-page__link timetable-page__link--class bold-text js-timetable-link" data-plan-id="${entry.class.id}" title="Plan oddziału">${entry.class.code}</a>`;
            }

            if (entry.room) {
              html += `<a href="?plan=${entry.room.id}" class="timetable-page__link timetable-page__link--room bold-text js-timetable-link" data-plan-id="${entry.room.id}" title="Plan sali">${entry.room.code}</a>`;
            }

            if (entry.group) {
              html += `<span class="timetable-page__group caption bold-text">${entry.group}</span>`;
            }

            html += `</div>`;
          });
          html += `</div>`;
        } else {
          html += `<span class="timetable-page__empty-cell" aria-hidden="true">&nbsp;</span>`;
        }

        html += `</td>`;
      }

      html += `</tr>`;
    });

    html += `
        </tbody>
      </table>
    `;

    return html;
  }

  /**
   * Pobiera plan z backendu i aktualizuje widok
   */
  let abortController = null;

  function loadPlan(planId, updateHistory = true) {
    if (!planId) return;

    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();

    currentPlanId = planId;
    syncSelectsWithPlanId(planId);

    if (tableWrapper) {
      tableWrapper.classList.add('timetable-page__table-wrapper--loading');
      tableWrapper.setAttribute('aria-busy', 'true');
    }

    const url = new URL(ajaxUrl, window.location.origin);
    url.searchParams.set('action', 'tzn_get_timetable');
    url.searchParams.set('plan', planId);

    fetch(url.toString(), {
      signal: abortController.signal,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (tableWrapper) {
          tableWrapper.classList.remove(
            'timetable-page__table-wrapper--loading',
          );
          tableWrapper.setAttribute('aria-busy', 'false');
        }

        if (data.success && data.data && data.data.plan) {
          const plan = data.data.plan;

          if (titleElem && plan.title) {
            titleElem.textContent = plan.title;
          }

          if (notesElem) {
            notesElem.textContent = plan.op_info || '';
          }

          if (generatedWrapper && generatedDateElem) {
            if (plan.generated_at) {
              generatedDateElem.textContent = plan.generated_at;
              generatedWrapper.style.display = '';
            } else {
              generatedWrapper.style.display = 'none';
            }
          }

          if (tableWrapper) {
            tableWrapper.innerHTML = buildTableHtml(plan);
          }

          if (updateHistory) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('plan', planId);
            window.history.pushState({ planId }, '', newUrl.toString());
          }
        }
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        if (tableWrapper) {
          tableWrapper.classList.remove(
            'timetable-page__table-wrapper--loading',
          );
          tableWrapper.setAttribute('aria-busy', 'false');
          tableWrapper.innerHTML = `
            <div class="timetable-page__error">
              <p class="medium-text">Wystąpił błąd podczas ładowania planu lekcji. Spróbuj ponownie później.</p>
            </div>
          `;
        }
      });
  }

  // Obsługa wyboru ze selectów
  if (selectOddzialy) {
    selectOddzialy.addEventListener('change', (e) => {
      const val = e.target.value;
      if (val) {
        if (selectNauczyciele) selectNauczyciele.selectedIndex = 0;
        if (selectSale) selectSale.selectedIndex = 0;
        loadPlan('o' + val);
      }
    });
  }

  if (selectNauczyciele) {
    selectNauczyciele.addEventListener('change', (e) => {
      const val = e.target.value;
      if (val) {
        if (selectOddzialy) selectOddzialy.selectedIndex = 0;
        if (selectSale) selectSale.selectedIndex = 0;
        loadPlan('n' + val);
      }
    });
  }

  if (selectSale) {
    selectSale.addEventListener('change', (e) => {
      const val = e.target.value;
      if (val) {
        if (selectOddzialy) selectOddzialy.selectedIndex = 0;
        if (selectNauczyciele) selectNauczyciele.selectedIndex = 0;
        loadPlan('s' + val);
      }
    });
  }

  // Obsługa przycisku "Sprawdź"
  if (submitBtn) {
    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      let targetPlan = '';

      if (selectOddzialy && selectOddzialy.value) {
        targetPlan = 'o' + selectOddzialy.value;
      } else if (selectNauczyciele && selectNauczyciele.value) {
        targetPlan = 'n' + selectNauczyciele.value;
      } else if (selectSale && selectSale.value) {
        targetPlan = 's' + selectSale.value;
      }

      if (targetPlan && targetPlan !== currentPlanId) {
        loadPlan(targetPlan);
      }
    });
  }

  // Obsługa przycisku "Drukuj"
  const printBtn = root.querySelector('.js-timetable-print');
  if (printBtn) {
    printBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.print();
    });
  }

  // Delegacja kliknięć w odnośniki wewnątrz tabeli
  if (tableWrapper) {
    tableWrapper.addEventListener('click', (e) => {
      const link = e.target.closest('.js-timetable-link');
      if (link) {
        e.preventDefault();
        const planId = link.getAttribute('data-plan-id');
        if (planId) {
          loadPlan(planId);
        }
      }
    });
  }

  // Obsługa wstecz/wprzód w przeglądarce
  window.addEventListener('popstate', (e) => {
    let planId = e.state && e.state.planId;
    if (!planId) {
      const params = new URLSearchParams(window.location.search);
      planId = params.get('plan') || 'o1';
    }
    loadPlan(planId, false);
  });
}

/**
 * Obsługa podświetlania aktualnej lekcji na stronie dzwonków
 */
function initBellsTable() {
  const table = document.querySelector('.js-bells-table');
  if (!table) return;

  const rows = table.querySelectorAll('.js-bells-row');
  if (!rows.length) return;

  function updateActiveLesson() {
    const now = new Date();
    const day = now.getDay();
    // 0 = Niedziela, 6 = Sobota
    const isWeekend = day === 0 || day === 6;
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    rows.forEach((row) => {
      const prefixEl = row.querySelector('.js-bells-prefix');
      const statusEl = row.querySelector('.js-bells-status');
      const labelEl = row.querySelector('.js-bells-label');
      const hoursAttr = row.getAttribute('data-hours') || '';

      row.classList.remove('is-current');
      if (prefixEl) prefixEl.textContent = '';
      if (statusEl) statusEl.textContent = '';

      if (isWeekend || !hoursAttr) return;

      const parts = hoursAttr.split('-').map((s) => s.trim());
      if (parts.length === 2) {
        const [startH, startM] = parts[0].split(':').map(Number);
        const [endH, endM] = parts[1].split(':').map(Number);

        if (!isNaN(startH) && !isNaN(startM) && !isNaN(endH) && !isNaN(endM)) {
          const startTotal = startH * 60 + startM;
          const endTotal = endH * 60 + endM;

          if (currentMinutes >= startTotal && currentMinutes <= endTotal) {
            row.classList.add('is-current');
            if (prefixEl) {
              prefixEl.textContent = 'Teraz trwa ';
            }
            if (statusEl) {
              statusEl.textContent = 'Aktualnie trwa: ';
            }
          }
        }
      }
    });
  }

  updateActiveLesson();
  setInterval(updateActiveLesson, 60000);
}

document.addEventListener('DOMContentLoaded', () => {
  initTimetable();
  initBellsTable();
});

